import {
  createComponentPreviewMapperModel,
  withCompPreviewInfo,
} from '@wix/editor-elements-integrations';
import {
  VerticalLineDefinition,
  VerticalLineSkin,
} from '../VerticalLine.types';

const isInEditor = (viewMode: string) => viewMode === 'editor';

const skinsWithMinHeight: Array<VerticalLineSkin> = [
  'VerticalDottedLine',
  'VerticalDashedLine',
  'VerticalSolidLine',
];

const css = withCompPreviewInfo<
  { 'min-width'?: string },
  VerticalLineDefinition
>()(['skin', 'componentViewMode'], ({ skin, componentViewMode }) => {
  return isInEditor(componentViewMode) && skinsWithMinHeight.includes(skin)
    ? { 'min-width': '10px !important' }
    : {};
});

export default createComponentPreviewMapperModel({
  css,
});
